import MarketSection   from './MarketSection';
import ConflictSection from '../ConflictSummary/ConflictSection';

// Market and Conflict sections each have their own independent state dropdown.
export default function MarketConflictSummary() {
  return (
    <div className="flex flex-col gap-6">
      <MarketSection />
      <ConflictSection />
    </div>
  );
}
